import script from "./ItemDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDialog.vue?vue&type=script&setup=true&lang=js"

import "./ItemDialog.vue?vue&type=style&index=0&id=53f93e78&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f93e78"]])

export default __exports__